<template>
  <div class="paper-manage">
    <div class="paper-manage-header">
      <div class="title">报纸管理</div>
      <div class="btn-wrapper" v-show="booksCurrentSubAccount == '' || !isSubAccount">
        <div class="create-btn" @click="addPaper">创建报纸</div>
        <div class="create-btn" @click="shareAllPaper">分享全部报纸</div>
        <div class="create-btn" v-show="booksCurrentSubAccount == ''" @click="batchRevoke">批量撤版</div>
      </div>
    </div>
    <List class="questionnaire-list" @flipPage="flipPage" :totalCount="totalCount" :currentPage="currentPageNo" :pageSize="10">
      <template v-slot:listContent>
        <div class="paper-list-content">
          <el-table :data="tableData" border style="width: 100%" :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
            <el-table-column prop="name" label="报纸名称" min-width="100">
              <template slot-scope="scope">
                <a :href="'/ebook/baozhi/index.jhtml?id=' + scope.row.id" target="_blank" class="updateContent">{{ scope.row.name }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="releaseQuantity" label="已发布数量" min-width="50"> </el-table-column>
            <el-table-column prop="updateTime" label="最近更新时间" min-width="100"> </el-table-column>
            <el-table-column prop="updateContent" label="更新内容" min-width="200">
              <template slot-scope="scope">
                <a :href="scope.row.link" target="_blank" class="updateContent">{{ scope.row.updateContent }}</a>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="180" :class-name="booksCurrentSubAccount !== '' && isSubAccount ? 'no-pointer-wrapper' : ''">
              <template slot-scope="scope">
                <div class="option-button" v-if="scope.row.isMigrateAuth" @click="toDataMigration(scope.row)">数据迁移</div>
                <div class="option-button" @click="shareItem(scope.row)">分享</div>
                <!-- <div class="option-button" @click="editItem(scope.row)">修改名称</div>
                <div class="option-button" @click="switchStyle(scope.row)">报纸样式</div> -->
                <div class="option-button" @click="setItem(scope.row)">报纸设置</div>
                <div class="option-button" @click="setDefault(scope.row)">默认效果</div>
                <div class="option-button" @click="deleteItem(scope.row)">删除</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </List>
    <add-tip-dialog class="add-tip" ref="buildDialog" :dialogOptions="buildDialogOptions" @clickConfirm="clickBuildConfirm"></add-tip-dialog>
    <add-tip-dialog class="add-tip" ref="editDialog" :dialogOptions="editDialogOptions" @clickConfirm="clickEditConfirm"></add-tip-dialog>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
    <tip-dialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" @clickConfirm="clickDeleteConfirm"></tip-dialog>
    <tip-dialog ref="managerPermissionDialog" :dialogOptions="managerPermissionDialogOptions"></tip-dialog>
    <share-dialog ref="shareDialog" :qrObj="qrObj" :typeName="typeName" :title="'分享报纸'" :isInset="isInset"></share-dialog>
    <share-dialog ref="shareAllDialog" :qrObj="qrObj" :showButtons="[true, true, true]" :typeName="typeName" :title="'分享全部报纸'" :isInset="isInset" @handleClick="handleClick"></share-dialog>
    <edit-share ref="editShare"></edit-share>
    <edit-share-content ref="editShareContent"></edit-share-content>
    <button-display-set ref="buttonSet"></button-display-set>
    <paper-style ref="paperStyleRef" />
    <paper-set ref="paperSetRef" />
    <revoke-dialog ref="revokeDialog" @showRevokeHistory="showRevokeHistory"></revoke-dialog>
    <revoke-history-dialog ref="revokeHistoryDialog"></revoke-history-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import List from '@components/list/listFrame'
import AddTipDialog from '@components/common/AddTipDialog.vue'
import TipDialog from '../../common/TipDialog'
import compareVipRight from '@components/common/compareVipRight.js'
import ShareDialog from '@components/books/components/ShareDialog.vue'
import EditShare from './editShare'
import EditShareContent from './editShareContent'
import api from '@api/paperManager'
import subAccount from '@api/subAccount'
import moment from 'moment'
import ButtonDisplaySet from '@components/PaperManagement/components/ButtonDisplaySet'
import paperStyle from '@components/PaperManagement/components/PaperStyleDialog'
import paperSet from '@components/PaperManagement/components/PaperSetDialog'
import RevokeDialog from './RevokeDialog.vue'
import RevokeHistoryDialog from './RevokeHistoryDialog.vue'
export default {
  name: 'paperManagement',
  mixins: [compareVipRight],
  data() {
    return {
      totalCount: 0,
      currentPageNo: 1,
      tableData: [],
      editId: '',
      deleteId: '',
      isInset: true,
      typeName: 'paper',
      buildDialogOptions: {
        // 弹框类型
        type: 'build',
        // 弹框头部标题
        title: '创建报纸',
        // 弹框内容
        label: '请输入报纸名称',
        value: '',
        message: '必须填写报纸名称'
      },
      editDialogOptions: {
        // 弹框类型
        type: 'build',
        // 弹框头部标题
        title: '编辑报纸',
        // 弹框内容
        label: '请输入报纸名称',
        value: '',
        message: '必须填写报纸名称'
      },
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '删除后将无法恢复，重新创建需要对全部数字报纸重新设置关联，是否确定删除？'
      },
      managerPermissionDialogOptions: {
        // 弹框类型
        type: '',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '主账号尚未赋予您操作权限，如需操作，请联系主账号管理员。'
      },
      qrObj: {
        value: '',
        iframeUrl: '',
        isShowPoster: 0,
        title: '',
        qrVal: ''
      },
      userMigrateAuthList: [],
      managePaper: 0 // 管理权限
    }
  },
  computed: {
    ...mapState('manage', ['booksCurrentSubAccount']),
    memberDialogOptions() {
      return {
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，仅允许创建${this.$store.state.common.vipRight.epaperClassifyNum}个报纸，创建更多需先升级会员服务。`
      }
    },
    userName() {
      return localStorage.getItem('username')
    },
    isSubAccount() {
      return this.$store.state.common.isSubAccount
    }
  },
  methods: {
    showRevokeHistory() {
      this.$refs.revokeHistoryDialog.dialogVisible = true
      this.$refs.revokeHistoryDialog.currentPageNo = 1
      this.$refs.revokeHistoryDialog.getRecordList()
    },
    getManagerList() {
      const param = {
        pageNo: this.currentPageNo,
        pageSize: 10,
        userName: this.booksCurrentSubAccount !== '' ? this.booksCurrentSubAccount : this.userName
      }
      api.getPaperManagerList(param).then(async (res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.tableData = res.data.data.content.map((item, index) => {
            let routeUrl = this.$router.resolve({
              path: '/paper',
              query: { id: item.updateWorkId }
            })
            return {
              ...item,
              updateTime: moment(item.updateTime).format('YYYY-MM-DD HH:mm'),
              link: routeUrl.href
            }
          })
          this.totalCount = res.data.data.totalElements
          await this.getUserMigrateAuthList()
        } else {
          this.tableData = []
        }
      })
    },
    flipPage(pageNo) {
      this.currentPageNo = pageNo
      this.getManagerList()
    },
    setHeaderCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
      } else {
        return { 'background-color': '#fafafa', color: '#333' }
      }
    },
    setCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return 'text-align: center'
      }
    },
    async addPaper() {
      if (!this.managePaperPermission()) {
        return
      }
      if (await this.compareRight({ type: 'num', key: 'epaperClassifyNum', value: this.tableData.length })) {
        this.$refs.buildDialog.visible = true
      } else {
        this.memberDialogOptions.tip = `您当前为${this.$store.state.common.vipRight.name}，仅允许创建${this.$store.state.common.vipRight.epaperClassifyNum}个报纸，创建更多需先升级会员服务。`
        this.$refs.memberDialog.visible = true
      }
    },
    shareAllPaper() {
      if (!this.managePaperPermission()) {
        return
      }
      this.$refs.shareAllDialog.dialogVisible = true
      this.qrObj.value = window.location.href.replace('list', 'paperSharePage?user=' + (this.booksCurrentSubAccount || this.userName))
      this.qrObj.iframeUrl = '<iframe src="' + this.qrObj.value + '" style="width:100%;height:99.5%"></iframe>'
    },
    clickBuildConfirm(item) {
      let param = {
        baozhiName: item,
        userName: this.booksCurrentSubAccount || this.userName
      }
      api.addPaperManager(param).then((res) => {
        if (res.data.status === 0) {
          this.getManagerList()
        } else {
          this.$message({
            message: res.message || '保存失败',
            type: 'error'
          })
        }
      })
    },
    shareItem(item) {
      if (!this.managePaperPermission()) return
      this.qrObj.value = window.location.origin + '/ebook/baozhi/index.jhtml?id=' + item.id
      if (item.style == 1) {
        // this.qrObj.value = window.location.origin + '/elecPublish/index.html#/paperContentTurn?id=' + item.id
        this.qrObj.qrVal = window.location.origin + '/elecPublish/paperContent?id=' + item.id
      }
      this.$refs.shareDialog.dialogVisible = true
      this.qrObj.iframeUrl = '<iframe src="' + this.qrObj.value + '" style="width:100%;height:99.5%"></iframe>'
      this.qrObj.title = item.name
      api.wxShareParams({ id: item.id, currentUrl: 'http://www-fxcloud.devx.fzyun.io/ebook/baozhi/index.jhtml?id=' + item.id })
    },
    deleteItem(item) {
      if (!this.managePaperPermission()) return
      this.deleteId = item.id
      this.$refs.deleteDialog.visible = true
    },
    clickDeleteConfirm() {
      let param = {
        ids: this.deleteId
      }
      api.deletePaperManager(param).then((res) => {
        if (res.data.status === 0) {
          this.getManagerList()
        } else {
          this.$message({
            message: res.message || '删除失败',
            type: 'error'
          })
        }
      })
    },
    editItem(item) {
      this.editId = item.id
      this.$refs.editDialog.visible = true
    },
    setItem(item) {
      if (!this.managePaperPermission()) return
      this.editId = item.id
      this.$refs.paperSetRef.init(item.id)
    },
    clickEditConfirm(item) {
      let param = {
        id: this.editId,
        name: item
      }
      api.modifyPaperManager(param).then((res) => {
        if (res.data.status === 0) {
          this.getManagerList()
        } else {
          this.$message({
            message: res.message || '保存失败',
            type: 'error'
          })
        }
      })
    },
    handleClick(val) {
      this.$refs.shareAllDialog.dialogVisible = false
      if (val === 1) {
        this.$refs.editShare.dialogVisible = true
      } else if (val === 2) {
        this.$refs.editShareContent.dialogVisible = true
      } else if (val === 3) {
        if (this.compare({ type: 'boole', key: 'displaySet' })) {
          this.$refs.buttonSet.dialogVisible = true
        } else {
          this.memberDialogOptions.tip = `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务。`
          this.$refs.memberDialog.visible = true
        }
      }
    },
    setDefault(item) {
      if (!this.managePaperPermission()) return
      this.$emit('defaultSetting', item)
      this.$store.commit('book/UPDATE_IS_PAPER', true)
      this.$store.commit('config/UPDATE_PAPERSTYLE', item.style)
    },
    toDataMigration(item) {
      this.$emit('get-migration', item)
      /*let routeUrl = this.$router.resolve({
        path: '/dataMigration'
      })
      let url = routeUrl.href*/
      localStorage.setItem('paper', item.name)
    },
    getUserMigrateAuthList() {
      const param = {
        userName: this.userName
      }
      api.getUserMigrateAuthList(param).then((res) => {
        if (res.data.status === 0) {
          this.userMigrateAuthList = res.data.data
          this.tableData.map((table) => {
            this.userMigrateAuthList.forEach((auth) => {
              if (table.id == auth.newspaperId) {
                this.$set(table, 'isMigrateAuth', true)
              }
            })
          })
        }
      })
    },
    switchStyle(item) {
      this.$refs.paperStyleRef.open(item)
    },
    batchRevoke() {
      this.$refs.revokeDialog.dialogVisible = true
    },
    managePaperPermission() {
      if (this.isSubAccount === 1 && this.managePaper !== 1) {
        this.$refs.managerPermissionDialog.visible = true
        return false
      } else {
        return true
      }
    }
  },
  async created() {
    this.isInset = (await this.compare({ type: 'boole', key: 'embedWebsite' })) === 1
    await this.getManagerList()
    if (this.isSubAccount === 1) {
      subAccount.getChildAccount({ childName: this.userName }).then((res) => {
        if (res.data?.status === 0) {
          this.managePaper = res.data.data.managePaper
        }
      })
    }
    // await this.getUserMigrateAuthList()
  },
  components: {
    ButtonDisplaySet,
    TipDialog,
    List,
    AddTipDialog,
    ShareDialog,
    EditShare,
    EditShareContent,
    paperStyle,
    RevokeDialog,
    RevokeHistoryDialog,
    paperSet
  },
  watch: {
    booksCurrentSubAccount() {
      this.getManagerList()
    }
  }
}
</script>
<style lang="scss" scoped>
.paper-manage {
  padding: 10px 18px 0 18px;
  width: 100%;
  .paper-manage-header {
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    .btn-wrapper {
      display: flex;
      .create-btn {
        width: 140px;
        height: 30px;
        font-weight: 500;
        color: #ffffff;
        line-height: 30px;
        background-color: #df5813;
        border-radius: 6px;
        text-align: center;
        cursor: pointer;
        margin-left: 20px;
      }
    }
  }
  a.updateContent {
    color: unset;
    text-decoration: none;
  }
  .option-button {
    display: inline-block;
    cursor: pointer;
    color: #df5813;
    margin-right: 20px;
  }
  .no-pointer-wrapper {
    .option-button {
      pointer-events: none;
      color: #9b9aa7;
    }
  }
}
</style>
<style lang="scss">
.add-tip {
  .el-dialog {
    .el-dialog__body {
      .dialog-input-container {
        label {
          font-size: 12px;
          color: #515151;
        }
        .el-input {
          width: 250px;
        }
      }
    }
  }
}
</style>
